import { h, Component, createRef } from 'preact';
import { useState } from 'preact/hooks';
import { Text } from 'preact-i18n';
import Markup from 'preact-markup';
import Carousel from 'preact-flickity-component';
import '../../../node_modules/flickity/dist/flickity.css';
import Isotope from 'isotope-layout';
import { } from 'flickity-fade';
import 'flickity-fade/flickity-fade.css';
import { } from 'flickity-as-nav-for';
import HtmlToText from 'html-to-text';
import { GetSafeImageUrl } from '../../utils/ApiUtil';

export const OneImage = props => {
  const [imageBlock, setImageBlock] = useState(props.imageBlock);
  let height = 110;
  let width = Math.round(height * imageBlock.thumbnail.width / imageBlock.thumbnail.height);
  let title = HtmlToText.htmlToText(imageBlock.name);
  return (
    <div className="image-block">
      <div className="result-image">
          <div>
            <a href={imageBlock.contentUrl}>
              <img src={GetSafeImageUrl(imageBlock.thumbnailUrl + "&h=" + height + "&w=" + width)} height={height} width={width} title={title} alt={title} />
            </a>
          </div>
      </div>
    </div>
  )
}
export const OneNavImage = props => {
  const [imageBlock, setImageBlock] = useState(props.imageBlock);
  let height = 74;
  let width = Math.round(height * imageBlock.thumbnail.width / imageBlock.thumbnail.height);
  let title = HtmlToText.htmlToText(imageBlock.name);
  return (
    <div className="image-block">
      <div className="result-image">
          <div>
            <img src={GetSafeImageUrl(imageBlock.thumbnailUrl + "&h=" + height + "&w=" + width)} height={height} width={width} title={title} alt={title} />
          </div>
      </div>
    </div>
  )
}
export const OneImageSnippets = props => {
  const [imageBlock, setImageBlock] = useState(props.imageBlock);
  let height = 150;
  let width = Math.round(height * imageBlock.thumbnail.width / imageBlock.thumbnail.height);
  let title = HtmlToText.htmlToText(imageBlock.name);

  let hosturl = new URL(imageBlock.hostPageUrl);
  let hostdomain = hosturl.hostname;

  return (
    <a href={imageBlock.contentUrl} style={{width: width+5}}>
      <div className="image-snippet">
        <img src={GetSafeImageLink(imageBlock.thumbnailUrl + "&h=" + height + "&w=" + width)} height={height} width={width} title={title} alt={title} />
        <div className="ae-caption ae-ellipsis image-snippet-words" style={{width: width}}>
          <Markup markup={imageBlock.name} type="html" trim={false}/>
          {hostdomain}
        </div>
      </div>
    </a>
  )
}
export const Images = props =>  {
  const [item, setItem] = useState(props.item);
  const [searchResp, setSearchResp] = useState(props.searchResp);
  const [query, setQuery] = useState(props.query);
  const [section, setSection] = useState(props.section);
  if(!item || item.answerType !== "Images") {
    return (""); //defensive check
  }
  let imgBlocks = searchResp.images?.value;
  return (
    <div className="result-block images-block">
      <div className="result-title"><Text id="newSearch.images">Images</Text></div>
      <div className="result-videos">
        {imgBlocks.map((imageBlock, ix) => {
          if(section === "sidebar" && ix > 1) {
            return ("");
          } 
          return <OneImage imageBlock={imageBlock} />
        })}
      </div>
    </div>
  )
}
export const ImageCarousel = props =>  {
  const [item, setItem] = useState(props.item);
  const [searchResp, setSearchResp] = useState(props.searchResp);
  const [query, setQuery] = useState(props.query);
  const [section, setSection] = useState(props.section);
  const [affid, setAdffid] = useState(props.affid);
  if(!item || item.answerType !== "Images") {
    return (""); //defensive check
  }
  let imgBlocks = searchResp.images?.value;

  return (
    <div className="result-block images-block">
      <div className="ae-title result-title"><Text id="newSearch.images">Images</Text></div>
      <div className="ae-caption see-more-link">
        <a href={`/search?q=${encodeURIComponent(query)}&service=images&affid=${encodeURIComponent(affid)}`}><Text id="newSearch.seeMoreImages">See more images</Text></a>
      </div>
      { imgBlocks ?
      (<Carousel options={{wrapAround: false, pageDots: false, percentPosition: false, cellAlign: props.isRightToLeft ? 'right' : 'left', rightToLeft: props.isRightToLeft}}>
        {imgBlocks.map((imageBlock, ix) => {
          return <OneImage imageBlock={imageBlock}/>
        })} 
      </Carousel>) : ("")}
    </div>
  )
}
export const OneImageVert = props => {
  const [imageBlock, setImageBlock] = useState(props.imageBlock);
  let width = 140;
  let height = Math.round(width * imageBlock.thumbnail.height / imageBlock.thumbnail.width);
  let title = HtmlToText.htmlToText(imageBlock.name);

  return (
    <div className="image-vert">
      <img onClick={() => props.showImageInfoPanel(true, props.imageIndex)} src={GetSafeImageUrl(imageBlock.thumbnailUrl + "&h=" + height + "&w=" + width)} height={height} width={width} title={title} alt={title} />
    </div>
  )
}
export const ImageInfoPanel = props =>  {
  const [imageBlocks, setItem] = useState(props.images);
  return (
    <div>
      <Carousel className="image-nav" options={{pageDots: false, asNavFor: ".image-panel"}}>
        {imageBlocks.map(imageBlock => {
          return <OneNavImage imageBlock={imageBlock}/>
        })}
      </Carousel>
      <div className="ae-border-box selected-image-container">
        <div className="exit-panel-icon" onClick={() => props.showImageInfoPanel(false, 0)}>
          <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="var(--black)">
            <path d="M0 0h24v24H0V0z" fill="none"/>
            <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"/>
          </svg>
        </div>
        <Carousel className="image-panel" options={{pageDots: false, lazyLoad: 1, initialIndex : props.imageIndex, fade: true, percentPosition: false}}>
          {imageBlocks.map(imageBlock => {
            return <SelectedImage imageBlock={imageBlock} {...props}/>
          })}
        </Carousel>
      </div>
      {/* ToDo: Download Image ink */}
    </div>
  )
}
export const SelectedImage = props => {
  const [imageBlock, setImageBlock] = useState(props.imageBlock);
  let title = HtmlToText.htmlToText(imageBlock.name);
  return (
    <div className="selected-image-box">
      <div className="ae-subtitle selected-image-title">
        <Markup markup={imageBlock.name} type="html" trim={false}/>
        <a className="selected-image-url" href={imageBlock.hostPageUrl}>
          {new URL(imageBlock.hostPageUrl).host}
        </a>
      </div>
      <div className="selected-image-visit">
        <a href={imageBlock.contentUrl} target="_blank"><Text id="newSearch.viewImage">View image</Text></a>
      </div>
      <div className='selected-image-div'>
        <img className="selected-image" data-flickity-lazyload={GetSafeImageUrl(imageBlock.thumbnailUrl)} title={title} alt={title} />
      </div>
    </div>
  )
}
export class ImagesIsotope extends Component {
  constructor(props) {
    super(props);
    this.state = {
      images: this.props.images,
    }
    this.isotoperef = createRef(null);
    this.isotope = {};
  }

  componentDidMount() {    
    // create an isotope instance
    this.isotope = new Isotope( '#packedimages', {
      itemSelector: '.image-vert',
      masonry: {
        horizontalOrder: true,
        fitWidth: true,
      }
    });
  }

  componentWillUpdate(nextProps) {
    if(nextProps.images !== this.props.images) {
      this.setState(c => {c.images = nextProps.images; return c});
      // do we need to get rid of old images?
    }
  }
/*
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.images !== this.props.images || prevState.images != this.state.images) {
      let elems = this.isotope.getItemElements();
      if(elems) {
        this.isotope.remove(elems);
      }
      let nodelist = document.querySelectorAll('.image-vert')
      this.isotope.addItems(nodelist);
      this.isotope.arrange();
    }
  }
*/
  render() {
    return (
      <div id='packedimages' ref={this.isotoperef} className="result-section-packed-image">
        {this.state.images.map((image, index) => {return (<OneImageVert imageBlock={image} imageIndex={index} showImageInfoPanel={this.props.showImageInfoPanel}/>)})}
      </div>
    )
  }
}
export class ImageResults extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showImageInfoPanel: false,
      selectedImageIndex: 0
    }
    this.showImageInfoPanel = this.showImageInfoPanel.bind(this);
  }

  showImageInfoPanel(value, imageIndex) {
    this.setState(c => {
      c.showImageInfoPanel = value;
      c.selectedImageIndex = imageIndex;
      return c;
    });
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <div>
        { this.state.showImageInfoPanel ? <ImageInfoPanel images={this.props.images} imageIndex={this.state.selectedImageIndex} showImageInfoPanel={this.showImageInfoPanel}/>
        : 
        <ImagesIsotope images={this.props.images} showImageInfoPanel={this.showImageInfoPanel}/>
        }
      </div>
    )
  }
}